import React, { useState } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';

// This can be merged with CreateTemplate easily when time permits.

const CreateDocument = ({ show, handleClose, handleChange, handleSave, existing = [] }) => {
    const [formState, setFormState] = useState({
        name: '',
        description: '',
        type: '',
        templateId: '',
        templateVersion: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const resetForm = () => {
        setFormState({
            name: '',
            description: '',
            type: '',
            templateId: '',
            templateVersion: ''
        });
    };

    const handleCancel = () => {
        resetForm();
        handleClose();
    };

    const handleDropdownChange = (e) => {
        if (e.target.value === "") {
            setFormState({
                ...formState,
                templateId: '',
                templateVersion: ''
            });
        } else {
            const selectedTemplate = existing.find(template => template.id === e.target.value);
            if (selectedTemplate) {
                setFormState({
                    ...formState,
                    templateId: selectedTemplate.id,
                    templateVersion: selectedTemplate.version
                });
            } 
        }
    };

    const handleSaveClick = async () => {
        setIsLoading(true);
        try {
            await handleSave(formState);
        } catch (error) {
            console.error("Error saving document:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleCancel} className="dark-modal" backdropClassName="dark-backdrop">
            <Modal.Header closeButton={false} style={{ borderBottom: 'none' }}>
                <Modal.Title className="modal-form-title">Add New Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="d-flex flex-column gap-3">
                    <Form.Group controlId="formDocumentName" className="d-flex flex-column gap-0 align-items-start">
                        <Form.Label className="label-style-dark">Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formState.name}
                            onChange={(e) => {
                                setFormState({ ...formState, name: e.target.value });
                                handleChange(e); // Ensure handleChange is called
                            }}
                            className="form-control-dark"
                        />
                    </Form.Group>
                    <Form.Group controlId="formDocumentDescription" className="d-flex flex-column gap-0 align-items-start">
                        <Form.Label className="label-style-dark">Description</Form.Label>
                        <Form.Control
                            type="text"
                            name="description"
                            value={formState.description}
                            onChange={(e) => {
                                setFormState({ ...formState, description: e.target.value });
                                handleChange(e); // Ensure handleChange is called
                            }}
                            className="form-control-dark"
                        />
                    </Form.Group>
                    <Form.Group controlId="formDocumentType" className="d-flex flex-column gap-0 align-items-start">
                        <Form.Label className="label-style-dark">Type</Form.Label>
                        <Form.Control
                            type="text"
                            name="type"
                            value={formState.type}
                            onChange={(e) => {
                                setFormState({ ...formState, type: e.target.value });
                                handleChange(e); // Ensure handleChange is called
                            }}
                            className="form-control-dark"
                        />
                    </Form.Group>
                    <Form.Group controlId="formTemplate" className="d-flex flex-column gap-0 align-items-start">
                        <Form.Label className="label-style-dark">Template Name</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={handleDropdownChange}
                            className="form-control-dark dropdown-style"
                        >
                            <option value="">Template required</option>
                            {existing.map(template => (
                                <option key={template.id} value={template.id}>
                                    {template.name} ({template.version})
                                </option>
                            ))}
                        </Form.Control>
                        <input type="hidden" name="templateId" value={formState.templateId} />
                        <input type="hidden" name="templateVersion" value={formState.templateVersion} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleCancel} className="button-cancel-dark">Cancel</Button>
                <Button 
                    variant="secondary" 
                    onClick={handleSaveClick} 
                    className="button-save-dark"
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateDocument;
